import { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./login/Login";
import Home from "./super_dashboard/Home";
import AddNewCompany from "./super_dashboard/components/AddNewCompany";
import ManageCompanies from "./super_dashboard/components/ManageCompanies";
import AdminDashboard from "./admin_dashboard/AdminDasboard";
import AdminHome from "./admin_dashboard/components/Home";
import AddSupervisor from "./super_dashboard/components/AddSupervisor";
import ProtectedRoutes from "./ProtectedRoutes";
import { axiosInstance } from "./axiosInstance";
import Dashboard from "./super_dashboard/Dashboard";
import Products from "./admin_dashboard/components/Products";
import AddProducts from "./admin_dashboard/components/AddProducts";
import Customers from "./admin_dashboard/components/Customers";
import LoyaltyPoint from "./admin_dashboard/components/LoyaltyPoint";
import Users from "./admin_dashboard/components/Users";
import LowStock from "./admin_dashboard/components/LowStock";
import Sales from "./admin_dashboard/components/Sales";
import Profile from "./admin_dashboard/components/Profile";
import Category from "./admin_dashboard/components/Category";
import SubCategory from "./admin_dashboard/components/SubCategory";
import PaymentMethod from "./admin_dashboard/components/PaymentMethod";
import { ToastContainer } from "react-toastify";

import MAdminDashboard from "./manager_dashboard/ManagerDasboard";
import MAdminHome from "./manager_dashboard/components/Home";
import MProducts from "./manager_dashboard/components/Products";
import MAddProducts from "./manager_dashboard/components/AddProducts";
import MCustomers from "./manager_dashboard/components/Customers";
// import MLoyaltyPoint from "./manager_dashboard/components/LoyaltyPoint";
import MUsers from "./manager_dashboard/components/Users";
import MLowStock from "./manager_dashboard/components/LowStock";
import MSales from "./manager_dashboard/components/Sales";
import MProfile from "./manager_dashboard/components/Profile";
import MCategory from "./manager_dashboard/components/Category";
import MSubCategory from "./manager_dashboard/components/SubCategory";

import CashierHomepage from "./cashier_homepage/CashierHomepage";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Loan from "./admin_dashboard/components/loan/Loan.jsx";
import Bill from "./admin_dashboard/components/Bill";
import ProfileDetailsProvider from "./context/ProfileDetailsProvider";
import SupervisorDashboard from "./supervisor_dashboard/SupervisorDashboard";
import DashboardContents from "./supervisor_dashboard/components/DashboardContents";
import StoreManagement from "./supervisor_dashboard/components/StoreManagement";
import UserManagement from "./supervisor_dashboard/components/UserManagement";
import AddNewStore from "./supervisor_dashboard/components/AddNewStore";
import ManageSupervisor from "./super_dashboard/components/ManageSupervisor";
import Chat from "./supervisor_dashboard/components/Chat";
import SupervisorProfile from "./supervisor_dashboard/components/Profile.jsx";
import Inventory from "./supervisor_dashboard/components/Inventory.jsx";
import LoanHome from "./admin_dashboard/components/loan/LoanHome.jsx";
import LoanManagerDashboard from "./loan_manager_dashboard/LoanManagerDashboard.jsx";
import LoanDashboardContents from "./loan_manager_dashboard/components/dashboard_page/LoanDashboardContents.jsx";
import RequestedLoans from "./loan_manager_dashboard/components/request_page/RequestedLoans.jsx";
import PendingLoan from "./loan_manager_dashboard/components/request_page/PendingLoan.jsx";
import ApprovedLoan from "./loan_manager_dashboard/components/request_page/ApprovedLoan.jsx";
import RejectedLoan from "./loan_manager_dashboard/components/request_page/RejectedLoan.jsx";
import VerificationPage from "./loan_manager_dashboard/components/verification_page/VerificationPage.jsx";
import PendingVerification from "./loan_manager_dashboard/components/verification_page/PendingVerification.jsx";
import AllVerification from "./loan_manager_dashboard/components/verification_page/AllVerification.jsx";
import DisputePage from "./loan_manager_dashboard/components/dispute_page/DisputePage.jsx";
import AllDispute from "./loan_manager_dashboard/components/dispute_page/AllDispute.jsx";
import PendingDispute from "./loan_manager_dashboard/components/dispute_page/PendingDispute.jsx";
import LogsPage from "./loan_manager_dashboard/components/logs_page/LogsPage.jsx";
import LoginRecords from "./loan_manager_dashboard/components/logs_page/LoginRecords.jsx";
import ActivityLogs from "./loan_manager_dashboard/components/logs_page/ActivityLogs.jsx";
import ResetPassword from "./reset_password/ResetPassword.jsx";
import axios from "axios";
import RestockPro from "./admin_dashboard/components/RestockPro.jsx";
import Orders from "./admin_dashboard/components/Orders.jsx";
import QueuedOrdersPage from "./admin_dashboard/components/QueuedOrdersPage.jsx";
import MQueuedOrdersPage from "./manager_dashboard/components/QueuedOrdersPage.jsx";
import Invoice from "./admin_dashboard/components/Invoice.jsx";
import Online from "./admin_dashboard/components/Online.jsx";
// import ProductsHeader from "./cashier_homepage/components/ProductsHeader";
// import CategoryListC from "./cashier_homepage/components/CategoryList";
// import AllProducts from "./cashier_homepage/components/AllProducts";
// import CartHeader from "./cashier_homepage/components/CartHeader";
import Signup from "./signup/Signup.jsx";
import Renew from "./renew/Renew.jsx";
import InvoicePaymentPage from "./invoice/InvoicePayment.jsx";
import PaymentCallbackPage from "./invoice/PaymentCallbackPage.jsx";
import Expenses from "./admin_dashboard/components/Expenses.jsx";

// Add WelcomeModal import
import WelcomeModal from "./components/WelcomeModal";
import ReportsPage from "./admin_dashboard/components/Reports.jsx";
import MobileBlocker from "./cashier_homepage/components/MobileBlocker.jsx";
import CashierErrorBoundary from "./cashier_homepage/components/CashierErrorBoundary.jsx";

// react-query pauses queries and mutations while the browser reports offline,
// which would stop the till's offline fallbacks from ever running.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { networkMode: "always" },
    mutations: { networkMode: "always" },
  },
});
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [status, setStatus] = useState(false);

  // Add state for welcome modal
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  const checkTokenValidity = async (tokenObject) => {
    const { accessToken, role } = JSON.parse(tokenObject);

    // Determine the endpoint based on the role
    const endpoint = {
      "Super Admin": "api/superadmin/dashboard/stats",
      Admin: "api/admin/users/profile",
      Manager: "api/managers/users/profile",
      Cashier: "api/cashiers/users/profile",
    }[role];

    // If no valid role is found, set authentication to false
    if (!endpoint) {
      setIsAuthenticated(false);
      setIsLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.get(endpoint, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      // console.log(response, accessToken);
      // If the response is valid, authenticate the user
      if (response.data.error === false) {
        setIsAuthenticated(true);
        // console.log(role);
        setUserRole(role);
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      // console.error("Error validating token:", error);
      if (role === "Cashier" && !error.response && accessToken) {
        // No connection: trust the stored login so the till keeps selling.
        setIsAuthenticated(true);
        setUserRole(role);
      } else {
        setIsAuthenticated(false);
      }
    } finally {
      setIsLoading(false); // Ensure loading state is always updated
    }
  };

  // Check for token on mount and validate it
  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      checkTokenValidity(storedToken); // Pass the entire token object as a string
    } else {
      setIsAuthenticated(false);
      setIsLoading(false);
    }
  }, []);

  // Handle token changes in sessionStorage from other tabs
  useEffect(() => {
    const handleStorageChange = () => {
      const storedToken = sessionStorage.getItem("token");
      if (storedToken) {
        checkTokenValidity(storedToken); // Check the validity again if the token changes
      } else {
        sessionStorage.clear();
        setIsAuthenticated(false);
        setIsLoading(false);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  // Show Welcome Modal for first login if no categories
  useEffect(() => {
    // Check if user is authenticated and if it's their first login
    if (isAuthenticated && userRole) {
      const hasSeenWelcome = sessionStorage.getItem("hasSeenWelcome");

      // You should fetch the category count from your API
      // For now, I'll show how to structure it
      const checkCategoryCount = async () => {
        try {
          const tokenString = sessionStorage.getItem("token");
          if (!tokenString) return;
          const { accessToken } = JSON.parse(tokenString);

          // Adjust endpoint based on role
          const endpoint =
            userRole === "Admin"
              ? "api/admin/categories"
              : "api/managers/categories";

          const response = await axiosInstance.get(endpoint, {
            headers: { Authorization: `Bearer ${accessToken}` },
          });

          // If no categories exist and user hasn't seen welcome
          if (response.data.data?.length === 0 && !hasSeenWelcome) {
            setShowWelcomeModal(true);
          }
        } catch (error) {
          console.error("Error checking categories:", error);
        }
      };

      if (!hasSeenWelcome) {
        if (userRole === "Admin" || userRole === "Manager") {
          checkCategoryCount();
        }
      }
    }
  }, [isAuthenticated, userRole]);

  // Handler for closing welcome modal
  const handleCloseWelcome = () => {
    setShowWelcomeModal(false);
    sessionStorage.setItem("hasSeenWelcome", "true");
  };

  // Handler for navigating to store/category creation
  const handleNavigateToStore = () => {
    setShowWelcomeModal(false);
    sessionStorage.setItem("hasSeenWelcome", "true");

    // Navigate based on role
    if (userRole === "Admin") {
      window.location.href = "/admin/category";
    } else if (userRole === "Manager") {
      window.location.href = "/manager/category";
    }
  };

  // If loading, show the loader
  // if (isLoading) {
  //   return (
  //     <div className="w-screen h-screen flex justify-center items-center">
  //       <img src={loader} alt="loader" className="w-10 lg:w-20" />
  //     </div>
  //   );
  // }

  const fetchValidity = async () => {
    try {
      const response = await axios.get(
        "https://controller-2slu.onrender.com/01pos",
      );
      setStatus(response.data);
      console.log(response);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchValidity();
  }, []);

  if (status) {
    return (
      <>
        <h1>An error occured</h1>
        <h1>Please contact admin</h1>
      </>
    );
  }

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ProfileDetailsProvider>
          <ToastContainer />
          {/* Add Welcome Modal */}
          <WelcomeModal
            isOpen={showWelcomeModal}
            onClose={handleCloseWelcome}
            onNavigate={handleNavigateToStore}
          />

          <Routes>
            <Route
              path="/login"
              element={
                <Login
                  setIsAuthenticated={setIsAuthenticated}
                  isLoading={isLoading}
                  setUserRole={setUserRole}
                />
              }
            />
            <Route path="/signup" element={<Signup />} />
            <Route path="/renew" element={<Renew />} />
            <Route
              path="/invoice/payment/:invoiceId"
              element={<InvoicePaymentPage />}
            />

            <Route
              path="/invoice/payment/callback"
              element={<PaymentCallbackPage />}
            />
            <Route path="/resetpassword" element={<ResetPassword />} />
            {/* Protect routes for authenticated users */}
            {/* <Route
              element={
                <ProtectedRoutes
                  isAuthenticated={isAuthenticated}
                  role={userRole}
                  requiredRole="Super Admin"
                />
              }
            > */}
            <Route path="/superadmin" element={<Dashboard />}>
              <Route index path="" element={<Home />} />
              <Route path="addcompany" element={<AddNewCompany />} />
              <Route path="manage" element={<ManageCompanies />} />
              <Route path="addsupervisor" element={<AddSupervisor />} />
              <Route path="managesupervisor" element={<ManageSupervisor />} />
            </Route>
            {/* </Route> */}

            {/* Admin routes */}
            <Route
              element={
                <ProtectedRoutes
                  isAuthenticated={isAuthenticated}
                  isLoading={isLoading}
                  role={userRole}
                  requiredRole="Admin"
                />
              }
            >
              <Route path="/admin" element={<AdminDashboard />}>
                <Route index path="" element={<AdminHome />} />
                <Route path="products" element={<Products />} />
                <Route path="addproduct" element={<AddProducts />} />
                <Route path="lowstock" element={<LowStock />} />
                <Route path="restock-pro" element={<RestockPro />} />
                <Route path="sales" element={<Sales />} />
                <Route path="customers" element={<Customers />} />
                <Route path="category" element={<Category />} />
                <Route path="subcategory" element={<SubCategory />} />
                <Route path="loyalty" element={<LoyaltyPoint />} />
                <Route path="users" element={<Users />} />
                <Route path="profile" element={<Profile />} />
                <Route path="orders" element={<Orders />} />
                <Route path="queued-orders" element={<QueuedOrdersPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="invoice" element={<Invoice />} />
                <Route path="online" element={<Online />} />
                <Route path="loan" element={<Loan />}>
                  <Route index path="" element={<LoanHome />} />
                </Route>

                <Route path="bill" element={<Bill />} />
                <Route path="expenses" element={<Expenses />} />
                <Route path="payment-method" element={<PaymentMethod />} />
              </Route>
            </Route>

            <Route
              element={
                <ProtectedRoutes
                  isAuthenticated={isAuthenticated}
                  isLoading={isLoading}
                  role={userRole}
                  requiredRole="Manager"
                />
              }
            >
              <Route path="/manager" element={<MAdminDashboard />}>
                <Route index path="" element={<MAdminHome />} />
                <Route path="products" element={<MProducts />} />
                <Route path="addproduct" element={<MAddProducts />} />
                <Route path="lowstock" element={<MLowStock />} />
                <Route path="sales" element={<MSales />} />
                <Route path="queued-orders" element={<MQueuedOrdersPage />} />
                <Route path="customers" element={<MCustomers />} />
                <Route path="category" element={<MCategory />} />
                <Route path="subcategory" element={<MSubCategory />} />
                {/* <Route path="loyalty" element={<MLoyaltyPoint />} /> */}
                <Route path="users" element={<MUsers />} />
                <Route path="profile" element={<MProfile />} />
              </Route>
            </Route>
            <Route
              element={
                <ProtectedRoutes
                  isAuthenticated={isAuthenticated}
                  isLoading={isLoading}
                  role={userRole}
                  requiredRole="Cashier"
                />
              }
            >
              <Route
                path="/cashier"
                element={
                  <MobileBlocker>
                    <CashierErrorBoundary>
                      <CashierHomepage />
                    </CashierErrorBoundary>
                  </MobileBlocker>
                }
              />
            </Route>

            <Route
              path="/supervisordashboard"
              element={<SupervisorDashboard />}
            >
              <Route index path="" element={<DashboardContents />} />
              <Route path="store" element={<StoreManagement />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="addstore" element={<AddNewStore />} />
              <Route path="chat" element={<Chat />} />
              <Route path="profile" element={<SupervisorProfile />} />
              <Route path="inventory" element={<Inventory />} />
            </Route>

            <Route
              path="/loanmanagerdashboard"
              element={<LoanManagerDashboard />}
            >
              <Route index path="" element={<LoanDashboardContents />} />
              <Route path="requests" element={<RequestedLoans />}>
                <Route path="" element={<PendingLoan />} />
                <Route path="approved" element={<ApprovedLoan />} />
                <Route path="rejected" element={<RejectedLoan />} />
              </Route>
              <Route path="verification" element={<VerificationPage />}>
                <Route path="" element={<PendingVerification />} />
                <Route path="all" element={<AllVerification />} />
              </Route>
              <Route path="disputes" element={<DisputePage />}>
                <Route path="" element={<PendingDispute />} />
                <Route path="all" element={<AllDispute />} />
              </Route>
              <Route path="logs" element={<LogsPage />}>
                <Route path="" element={<LoginRecords />} />
                <Route path="activity" element={<ActivityLogs />} />
              </Route>
            </Route>

            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </ProfileDetailsProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
